module.exports = __webpack_public_path__ + "static/img/TP@2x.2ff6dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/TP@2x.png
// module id = lVdP
// module chunks = 44